import React, { Component } from "react";
import { connect } from "react-redux";

import Header from "../common/HeaderAfterLogin";
import AuthHeader from "../salesUser/common/AuthHeader";
import UserSideMenu from "../../menu/UserSideMenu";

import { KYC_DETAILS } from "../../action/user_action_types";
import DSATermsPopup from "../common/terms";
import {
  postServerDataWithTypes,
  postServerDataWithPath,
} from "../../action/common_action";
import Drag from "./dragNdDropKycFile";
import Model from "./model";
import PaymentModel from "./paymentModel";
import GetClientDetailModel from "./getClientDetailModel";
import {
  getUserData,
  getSalesUserData,
  razorPayKey,
  axiosInstnace as Axios,
  axiosInstnace,
} from "../../util/util";
import { fileUrl, endPoints } from "../../config";
import { history } from "../../history/history";
import { ToastContainer, toast } from "react-toastify";
import { CommonModelImpl } from "../common/CommonModel";
import copy from "copy-to-clipboard";
import SalesUserSideMenu from "../../menu/SalesUserSideMenu";
import { ShowStations } from "./ShowStations";

class KycDetail extends Component {
  // const [gstChecked, handleGstChecked] = useState(false);

  constructor(props) {
    super(props);
    //Set the initial state
    this.state = {
      userInfo: getUserData(),
      salesUserInfo: getSalesUserData(),
      packageDetails: undefined,
      handletermsandcondpopup: false,
      kycObj: {
        gst_Number: "",
        gst_Address: "",
        billing_Address: "",
        pan_number: "",
      },
      gst_Certificate_file: null,
      gst_Certificate_file_path: null,
      pan_Certificate_file: null,
      pan_Certificate_file_path: null,
      bill_address_cert_file: null,
      bill_address_cert_file_path: null,

      packageCost: null,
      compaignData: null,
      showModel: false,
      showPaymentModel: false,
      tandc: false,
      gstagree: false,
      gstChecked: false,
      campaignId: null,
      showstationlist: false,
      currentStations:[],
      savedraft: false,
      isClientKYCShowing: false,
      clientKYC: {}
    };
  }
  //Checking the KYC details
  componentWillMount = () => {
    if (this.props.location.state && this.props.location.state.compaignData) {
      let { compaignData, packageCost } = this.props.location.state;
      this.setState({ compaignData, packageCost });
    } else {
      history.push("/package");
    }
  };

  hideshowstations = (e) => {
    this.setState({showstationlist: !this.state.showstationlist});
  };

  //Fetching the kyc details
  componentDidMount = async () => {
    let { userInfo } = this.state;
    let data = {
      userEmail: userInfo.email,
    };
    this.props.getKycDetails(endPoints.getKycDetails, data, KYC_DETAILS);
  };

  //Set the data for KYC of user
  componentWillReceiveProps = (nextProps) => {
    let { kycDetails } = nextProps;
    let { kycObj } = this.state;
    console.log(kycDetails);
    if (kycDetails && kycDetails.length > 0) {
      let {
        gst_Number,
        gst_Address,
        billing_Address,
        gst_Certificate_file,
        pan_number,
        pan_card_cert_file,
        bill_address_cert_file,
      } = kycDetails[0];
      this.setState({
        kycObj: {
          ...kycObj,
          gst_Number,
          gst_Address,
          pan_number,
          billing_Address,
        },
        gst_Certificate_file_path: gst_Certificate_file,
        pan_Certificate_file_path: pan_card_cert_file,
        bill_address_cert_file_path: bill_address_cert_file,
      });
    }
  };

  acceptterms = () => {
    this.setState({
      tandc: true,
      handletermsandcondpopup: false,
    });
  };
  declineterms = () => {
    this.setState({
      tandc: false,
      handletermsandcondpopup: false,
    });
  };

  handleTermsandCond = (e) => {
    this.setState({
      handletermsandcondpopup: true,
    });
  };

  //Handle fields for kyc
  handleChange = (event) => {
    let { name, value } = event.target;
    let { kycObj } = this.state;
    if (this.state.gstChecked && name === "gst_Address") {
      this.setState({
        kycObj: {
          ...kycObj,
          [name]: value,
          billing_Address: value,
        },
      });
    } else {
      this.setState({
        kycObj: {
          ...kycObj,
          [name]: value,
        },
      });
    }
  };

  //Upload a file
  getUploadedFile = (files) => {
    this.setState({ gst_Certificate_file: files });
  };

  //Upload a file
  getUploadedFilePan = (files) => {
    this.setState({ pan_Certificate_file: files });
  };

  //Upload a file
  getUploadedFileBill = (files) => {
    this.setState({ bill_address_cert_file: files });
  };

  //Remove file
  removeFile = () => {
    if (this.state.gstChecked) {
      this.setState({
        gst_Certificate_file: null,
        gst_Certificate_file_path: null,
        bill_address_cert_file: null,
        bill_address_cert_file_path: null,
      });
    } else {
      this.setState({
        gst_Certificate_file: null,
        gst_Certificate_file_path: null,
      });
    }
  };

  //Remove file
  removeFilePan = () => {
    this.setState({
      pan_Certificate_file: null,
      pan_Certificate_file_path: null,
    });
  };

  //Remove file
  removeFileBill = () => {
    this.setState({
      bill_address_cert_file: null,
      bill_address_cert_file_path: null,
    });
  };

  //Create campaign
  createCampaign = async (payId) => {
    // debugger;
    let {
      compaignData,
      userInfo,
      kycObj,
      gst_Certificate_file,
      gst_Certificate_file_path,
      pan_Certificate_file,
      pan_Certificate_file_path,
      bill_address_cert_file,
      bill_address_cert_file_path,
      clientKYC
    } = this.state;
    let { gst_Address, billing_Address, gst_Number, pan_number } = kycObj;
    let { clientName, clientEmail, clientCompany, clientIndustry, clientState, clientCity, clientPAN, clientPANFile, clientGST, clientGSTFile, clientAddress, clientAddressProof } = clientKYC;
    debugger;
    let formData = new FormData();
    for (let key in compaignData) {
      if (key === "indivrodps") {
        formData.append("indivrodps", JSON.stringify(compaignData[key]));
      }else if(key == 'multiDurationAudioDetail' && Array.isArray(compaignData[key]) && compaignData[key].length){
        let multiDurationAudioData = compaignData[key].map( multiAudio => { 
          let returnObj = {audio: multiAudio.audio, audioLength: multiAudio.audioLength, numberOfDays: multiAudio.numberOfDays, rotationsPerDay: multiAudio.rotationsPerDay, totalSeconds: multiAudio.totalSeconds};
          if(!multiAudio.blob) returnObj.src = multiAudio.src;
          if(multiAudio.relativeSource) returnObj.src = multiAudio.relativeSource;
          return returnObj;
        });
        
        formData.append(`multiDurationAudioDetail`, JSON.stringify(multiDurationAudioData));
        
        compaignData[key].forEach((element, i) => {
          formData.append(`audio${i}`, element.blob);
        });
      }else if (
        key !== "files" ||
        !Array.isArray(compaignData[key])
      ) {
        formData.append(key, compaignData[key]);
      } else if (compaignData[key] && compaignData[key][0].audioUrlPath) {
        let data = compaignData[key].map((e) => {
          return e.audioUrlPath;
        });
        formData.append("audioUrls", JSON.stringify(data));
      } else {
        compaignData[key].forEach((element, i) => {
          formData.append(`audio${i}`, element);
        });
      }
    }
    formData.append("userEmail", userInfo.email);
    // formData.append("payId", payId);
    if (
      gst_Address ||
      billing_Address ||
      gst_Number ||
      gst_Certificate_file ||
      pan_Certificate_file ||
      bill_address_cert_file ||
      pan_number
    ) {
      formData.append("gst_Address", gst_Address);
      formData.append("gst_Number", gst_Number);
      formData.append("pan_number", pan_number);
      formData.append("billing_Address", billing_Address);

      if (gst_Certificate_file) {
        formData.append("gst_Certificate_file", gst_Certificate_file);
      }
      if (gst_Certificate_file_path) {
        formData.append("gst_Certificate_file_path", gst_Certificate_file_path);
      }

      if (pan_Certificate_file) {
        formData.append("pan_card_cert_file", pan_Certificate_file);
      }
      if (pan_Certificate_file_path) {
        formData.append("pan_card_cert_file_path", pan_Certificate_file_path);
      }

      if (bill_address_cert_file) {
        formData.append("bill_address_cert_file", bill_address_cert_file);
      }
      if (bill_address_cert_file_path) {
        formData.append(
          "bill_address_cert_file_path",
          bill_address_cert_file_path
        );
      }
    }
    
    if (clientName && clientEmail) {
      formData.append("clientName", clientName);
      formData.append("clientEmail", clientEmail);
      formData.append("clientCompany", clientCompany);
      formData.append("clientIndustry", clientIndustry);
      formData.append("clientState", clientState);
      formData.append("clientCity", clientCity);
      formData.append("clientPAN", clientPAN);
      formData.append("clientPANFile", clientPANFile);
      formData.append("clientGST", clientGST);
      formData.append("clientGSTFile", clientGSTFile);
      formData.append("clientAddress", clientAddress);
      formData.append("clientAddressProof", clientAddressProof);
    }
    //console.log(endPoints.createCampaign);
    /* for (var key of formData.entries()) {
      //console.log(key[0] + ', ' + key[1]);
    } */
    let campaign = await Axios.post(endPoints.createCampaign, formData);
    this.setState({
      campaignId: campaign.data.data[0]._id,
    }); //console.log(formData);
    // this.props.createCompain(
    //   endPoints.createCampaign,
    //   formData,
    //   "/comapignsuccess"
    // );
  };
  updatePayment(payId) {
    let data = {
      updateObj: {
        payId,
        paymentdates: {
          payId: +new Date(),
        },
      },
      _id: this.state.campaignId,
    };
    this.props.createCompain(
      endPoints.updateCampaign,
      data,
      "/comapignsuccess"
    );
  }

  //disable bill addres and proof and add with gst_Address  and proof
  handleChangeBilling(event) {
    console.log("gstChecked" + event.target);
    console.log("gstChecked" + this.state.gst_Certificate_file_path);
    const target = event.target;
    const gstChecked = target.checked;
    if (
      !this.state.gst_Certificate_file_path &&
      !this.state.gst_Certificate_file
    ) {
      toast.error("Please upload the GST Certificate to use this option", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      target.checked = false;
      return false;
    }
    if (!this.state.kycObj.gst_Address) {
      toast.error("Please provide the GST Address to use this option", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      target.checked = false;
      return false;
    }
    this.setState({
      gstChecked: gstChecked,
    });
    if (gstChecked && this.state.gst_Certificate_file_path) {
      this.setState({
        bill_address_cert_file_path: this.state.gst_Certificate_file_path,
      });
      this.state.kycObj.billing_Address = this.state.kycObj.gst_Address;
      console.log(this.state.kycObj.gst_Address);
      console.log(
        "bill_address_cert_file_path" + this.state.gst_Certificate_file_path
      );
    } else if (gstChecked && this.state.gst_Certificate_file) {
      this.setState({
        bill_address_cert_file_path: this.state.gst_Certificate_file.path,
      });
      this.setState({
        bill_address_cert_file: this.state.gst_Certificate_file,
      });
      this.state.kycObj.billing_Address = this.state.kycObj.gst_Address;
      console.log(this.state.kycObj.gst_Address);
      console.log(
        "bill_address_cert_file_path" + this.state.gst_Certificate_file_path
      );
    }
  }

  handleInputChangeGst = (event) => {
    console.log(event.target);
    const target = event.target;
    const gstAgree = target.checked;
    this.setState({
      gstagree: gstAgree,
    });
    const name = target.name;
  };
  submitTransactionDetails = async ({ refno, accountno, ifsc, amount ,paymentdate, savedraftValue}) => {
    if(savedraftValue !== this.state.savedraft){
      this.setState({
        savedraft: savedraftValue
      })
    }
    let data = {
      refno,
      campaignId: this.state.campaignId,
      campaignName: this.state.compaignData.name,
      ifsc,
      account_number: accountno,
      paymentdate,
      savedraft: savedraftValue,
      amount,
      email:this.state.userInfo.email,
      mobile: this.state.userInfo.mobile
    };
    // debugger
    let response = await Axios.post(endPoints.updateOfflineTransaction, data);
    if (response && response.data.statusCode == 200) {
      this.setState({
        savedraft: false,
      });
      let result = response.data.data;
      history.push("/comapignsuccess", { result });
    } else {
      if (
        response.data.message === "Please enter valid transaction Ref number"
      ) {
        this.setState({
          savedraft: true,
        });
      }
      this.handleToastError(response.data.message);
    }
  };
  //Make payment for campaign
  makePayment = async () => {
    this.setState({
      showPaymentModel: false,
    });
    let { compaignData, userInfo, packageCost } = this.state;
    let { totalCost } = compaignData;
    let { payableAmount } = 0;
    payableAmount = Math.round(totalCost - compaignData.pendingAmount);
    var options = {
      key: razorPayKey,
      amount: payableAmount * 100,
      name: "BigFm",
      description: "Purchase Description",
      image: "/assets/images/logo_blue.png",
      handler: async (response) => {
        const params = {
          payId: response.razorpay_payment_id,
          userEmail: userInfo.email,
          amount: payableAmount * 100,
        };
        this.updatePayment(params.payId);
      },
      prefill: {
        name: userInfo.name,
        contact: userInfo.mobile,
        email: userInfo.email,
      },
      notes: {
        agencyId: "",
        campaignId: this.state.campaignId,
        campaignName: this.state.compaignData.name,
      },
      theme: {
        color: "#1f7cc0",
      },
    };
    var rzp1 = new Razorpay(options);
    //console.log('RazorPay popup opened');
    rzp1.open();
  };

  //Go to Campaign
  goToCompaign = () => {
    this.setState(
      {
        showModel: false,
      },
      () => {
        history.push("/campaign");
      }
    );
  };

  showHideModel = () => {
    let { showModel } = this.state;
    this.setState({
      showModel: !showModel,
    });
  };
  showHidePaymentModel = async () => {
    console.log(this.state.tandc);
    console.log(this.state.gstagree);
    console.log(this.state.kycObj.pan_number);
    // console.log("value",value);
    if (this.state.kycObj.pan_number) {
      let regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
      if (regpan.test(this.state.kycObj.pan_number)) {
        // alert("Pan no alert >>>");
      } else {
        // alert("Pan number is invalid.Please give correct Pan number!!");
        toast.error("Pan number is invalid.Please give correct Pan number!!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: false,
          hideProgressBar: true,
          toastId: "1",
        });
        return false;
      }
    }
    console.log("Accepted");
    if (
      this.state.pan_Certificate_file ||
      this.state.pan_Certificate_file_path ||
      this.state.salesUserInfo
    ) {
      console.log("Pan certificate available");
    } else {
      this.handleToastError("Kindly upload Pan certificate to proceed");
      return;
    }

    console.log("Accepted");
    console.log("NOt accepted");

    if (
      (!this.state.kycObj.pan_number ||
        this.state.kycObj.pan_number.trim() === "") &&
      !this.state.salesUserInfo
    ) {
      this.handleToastError(
        "Kindly enter pan number and attach pan certificate to proceed"
      );
      return;
    } else if (
      !this.state.kycObj.gst_Number &&
      (this.state.gst_Certificate_file ||
        this.state.gst_Certificate_file_path) &&
      !this.state.salesUserInfo
    ) {
      this.handleToastError("Kindly enter GST Number to proceed");
      return;
    } else if (
      !this.state.bill_address_cert_file &&
      !this.state.bill_address_cert_file_path &&
      !this.state.gstChecked &&
      !this.state.salesUserInfo
    ) {
      this.handleToastError(
        "Kindly upload the proof for Billing address to proceed"
      );
      return;
    } else if (
      !this.state.bill_address_cert_file &&
      !this.state.bill_address_cert_file_path &&
      this.state.gstChecked &&
      !this.state.salesUserInfo
    ) {
      this.handleToastError("Kindly upload the GST Certificate to proceed");
      return;
    } else if (
      !this.state.bill_address_cert_file_path &&
      !this.state.bill_address_cert_file &&
      !this.state.gstChecked &&
      !this.state.salesUserInfo
    ) {
      this.handleToastError(
        "Kindly upload the proof of Billing Address to proceed"
      );
      return;
    } else if (
      !this.state.kycObj.billing_Address &&
      this.state.gstChecked &&
      !this.state.salesUserInfo
    ) {
      this.handleToastError("Kindly enter GST address to proceed");
      return;
    } else if (
      !this.state.kycObj.billing_Address &&
      !this.state.gstChecked &&
      !this.state.salesUserInfo
    ) {
      this.handleToastError("Kindly enter Billing address to proceed");
      return;
    } else if( this.state.userInfo.role == 'dsa' && !(this.state.clientKYC.clientName && this.state.clientKYC.clientEmail && this.state.clientKYC.clientCompany && this.state.clientKYC.clientIndustry && this.state.clientKYC.clientState && this.state.clientKYC.clientCity && this.state.clientKYC.clientPAN && this.state.clientKYC.clientPANFile && this.state.clientKYC.clientGST && this.state.clientKYC.clientGSTFile && this.state.clientKYC.clientAddress && this.state.clientKYC.clientAddressProof) ){
      this.handleToastError("Please submit client KYC to proceed");
      this.setState({ isClientKYCShowing: true });
      return;
    } else if (!this.state.gstagree) {
      this.handleToastError("Kindly accept GST disclaimer to proceed");
      return;
    } else if (!this.state.tandc) {
      this.handleToastError("Kindly accept Terms and Conditions to proceed");
      return;
    }
    if(!this.state.campaignId){
      await this.createCampaign(null);
    }
    let { showPaymentModel } = this.state;
    this.setState({
      showPaymentModel: !showPaymentModel,
    });
  };

  hidePaymentModel = ()=>{
    let { showPaymentModel } = this.state;
    this.setState({
      showPaymentModel: !showPaymentModel,
    });
  }

  handleInputChangeGst = (event) => {
    console.log(event.target);
    const target = event.target;
    const gstAgree = target.checked;
    this.setState({
      gstagree: gstAgree,
    });
    const name = target.name;
  };

  handleInputChangeTandC = (event) => {
    console.log(event.target);
    const target = event.target;
    const tandc = target.checked;
    this.setState({
      tandc: tandc,
    });
    const name = target.name;
  };
  //Error handling
  handleToastError = (error) => {
    console.log(error);
    toast.error(error, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: false,
      hideProgressBar: true,
      toastId: "3",
    });
  };

  gotoTandC = () => {};

  hideClientKYCModel = (clientKYC) => {
    this.setState({
      clientKYC: clientKYC,
      isClientKYCShowing: false
    })
  }

  closeClientKYCModel = () => {
    this.setState({
      isClientKYCShowing: false
    })
  }
  //Return the UI for KYC details of user
  render() {
    let {
      kycObj,
      gst_Certificate_file,
      gst_Certificate_file_path,
      pan_Certificate_file,
      pan_Certificate_file_path,
      bill_address_cert_file,
      bill_address_cert_file_path,
      compaignData,
      packageCost,
      showModel,
      showPaymentModel,
      userInfo,
      salesUserInfo,
    } = this.state;
    let { gst_Number, pan_number, billing_Address, gst_Address } = kycObj;
    console.log(pan_number);
    console.log(pan_Certificate_file);
    console.log(pan_Certificate_file_path);
    console.log(bill_address_cert_file_path);
    console.log(bill_address_cert_file);

    return (
      <div className="main_wrapper">
        {!salesUserInfo && <UserSideMenu {...this.props} />}
        {salesUserInfo && <SalesUserSideMenu {...this.props} />}
        <div className="dashboard_right_wrapper create_camp_container">
          <div className="right_wrapper_inner">
            {!salesUserInfo && <Header />}
            {SalesUserSideMenu && <AuthHeader />}
            <div className="dash_content_wrapper">
              <div className="content_wrapper_inner">
                <div className="create_camp_wrapper">
                  <div className="kyc_left_inner">
                    <div className="create_camp_details kyc_detail">
                      <h2 className="camp-detail_header">KYC Details</h2>
                      <div className="camp_detail_header">
                        <div className="kyc_input">
                          <table>
                            <tr>
                              <td>
                                <div className="pan_number_campaign">
                                  <div className="field_wrapper kyc_input_inner width95">
                                    <h6 className="camp_label">Pan Number</h6>
                                    <input
                                      type="text"
                                      name="pan_number"
                                      disabled={salesUserInfo}
                                      value={
                                        pan_number
                                          ? pan_number
                                          : userInfo.kycdetails &&
                                            userInfo.kycdetails.pannumber
                                          ? userInfo.kycdetails.pannumber
                                          : ""
                                      }
                                      placeholder="Enter PAN Number"
                                      onChange={this.handleChange}
                                      maxLength="10"
                                      pattern="[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}"
                                      required
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="lenght_file_wrapper pan_number_campaign">
                                  <div className="flie_audio">
                                    {!pan_Certificate_file &&
                                      !pan_Certificate_file_path &&
                                      (!salesUserInfo ||
                                        !salesUserInfo.uploadeddocuments) && (
                                        <div>
                                          <h6 className="camp_label">
                                            PAN Certificate
                                          </h6>
                                          <Drag
                                            getUploadedFile={
                                              this.getUploadedFilePan
                                            }
                                          />
                                        </div>
                                      )}
                                    {(pan_Certificate_file ||
                                      pan_Certificate_file_path) &&
                                      (!salesUserInfo ||
                                        !salesUserInfo.uploadeddocuments) && (
                                        <div className="upload_file">
                                          <h6 className="camp_label">
                                            Uploaded PAN File
                                          </h6>
                                          <div>
                                            <div className="audio_img">
                                              {" "}
                                              <img src="../../assets/images/song.svg" />
                                            </div>
                                            <div className="file_desc">
                                              <div className="file_name_size">
                                                <div className="file_name">
                                                  {pan_Certificate_file
                                                    ? pan_Certificate_file.path &&
                                                      pan_Certificate_file.path
                                                    : pan_Certificate_file_path.slice(
                                                        pan_Certificate_file_path.lastIndexOf(
                                                          "_"
                                                        ) + 1
                                                      )}
                                                </div>
                                                <span className="file_size">
                                                  {pan_Certificate_file
                                                    ? pan_Certificate_file.size
                                                    : null}
                                                </span>
                                              </div>
                                              <div
                                                className="remove_file"
                                                onClick={this.removeFilePan}
                                              >
                                                <a>REMOVE</a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    {salesUserInfo &&
                                      salesUserInfo.uploadeddocuments &&
                                      salesUserInfo.uploadeddocuments.pan && (
                                        <div className="upload_file">
                                          <h6 className="camp_label">
                                            Uploaded PAN File
                                          </h6>
                                          <div>
                                            <div className="audio_img">
                                              {" "}
                                              <img src="../../assets/images/song.svg" />
                                            </div>
                                            <div className="file_desc">
                                              <div className="file_name_size">
                                                <div className="file_name">
                                                  {
                                                    salesUserInfo.uploadeddocuments.pan.split(
                                                      "/"
                                                    )[
                                                      salesUserInfo.uploadeddocuments.pan.split(
                                                        "/"
                                                      ).length - 1
                                                    ]
                                                  }
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="field_wrapper kyc_input_inner width95">
                                  <h6 className="camp_label">GST Number</h6>
                                  <input
                                    type="text"
                                    name="gst_Number"
                                    disabled={salesUserInfo}
                                    value={
                                      gst_Number
                                        ? gst_Number
                                        : userInfo.kycdetails &&
                                          userInfo.kycdetails.gstnumber
                                        ? userInfo.kycdetails.gstnumber
                                        : ""
                                    }
                                    placeholder="Enter GST Number"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="lenght_file_wrapper">
                                  <div className="flie_audio">
                                    {!gst_Certificate_file &&
                                      !gst_Certificate_file_path &&
                                      (!salesUserInfo ||
                                        !salesUserInfo.uploadeddocuments) && (
                                        <div>
                                          <h6 className="camp_label">
                                            GST Certificate
                                          </h6>
                                          <Drag
                                            getUploadedFile={
                                              this.getUploadedFile
                                            }
                                          />
                                        </div>
                                      )}
                                    {(gst_Certificate_file ||
                                      gst_Certificate_file_path) &&
                                      (!salesUserInfo ||
                                        !salesUserInfo.uploadeddocuments) && (
                                        <div className="upload_file">
                                          <h6 className="camp_label">
                                            Uploaded GST File
                                          </h6>
                                          <div>
                                            <div className="audio_img">
                                              {" "}
                                              <img src="../../assets/images/song.svg" />
                                            </div>
                                            <div className="file_desc">
                                              <div className="file_name_size">
                                                <div className="file_name">
                                                  {gst_Certificate_file
                                                    ? gst_Certificate_file.path
                                                    : gst_Certificate_file_path.slice(
                                                        gst_Certificate_file_path.lastIndexOf(
                                                          "_"
                                                        ) + 1
                                                      )}
                                                </div>
                                                <span className="file_size">
                                                  {gst_Certificate_file
                                                    ? gst_Certificate_file.size
                                                    : null}
                                                </span>
                                              </div>
                                              <div
                                                className="remove_file"
                                                onClick={this.removeFile}
                                              >
                                                <a>REMOVE</a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    {salesUserInfo &&
                                      salesUserInfo.uploadeddocuments && (
                                        <div className="upload_file">
                                          <h6 className="camp_label">
                                            Uploaded GST File
                                          </h6>
                                          <div>
                                            <div className="audio_img">
                                              {" "}
                                              <img src="../../assets/images/song.svg" />
                                            </div>
                                            <div className="file_desc">
                                              <div className="file_name_size">
                                                <div className="file_name">
                                                  {salesUserInfo
                                                    .uploadeddocuments.gst
                                                    ? salesUserInfo.uploadeddocuments.gst.split(
                                                        "/"
                                                      )[
                                                        salesUserInfo.uploadeddocuments.gst.split(
                                                          "/"
                                                        ).length - 1
                                                      ]
                                                    : "Not Available"}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="2">
                                <div>
                                  <h6 className="camp_label">GST Address</h6>
                                  <textarea
                                    className="gst_address"
                                    rows="3"
                                    cols="40"
                                    name="gst_Address"
                                    value={gst_Address ? gst_Address : ""}
                                    onChange={this.handleChange}
                                    disabled={salesUserInfo}
                                    placeholder="Enter GST Address"
                                  ></textarea>
                                  <h6 className="camp_label margn-top-10">
                                    {" "}
                                    <b>
                                      {" "}
                                      ** If GST address proof is not available
                                      or GST address differs from your billing
                                      address then kindly update your billing
                                      address and upload copy of your billing
                                      address proof below.{" "}
                                    </b>{" "}
                                  </h6>
                                  <div>
                                    <input
                                      className="margn-rgt-10"
                                      type="checkbox"
                                      onChange={this.handleChangeBilling.bind(
                                        this
                                      )}
                                      disabled={salesUserInfo}
                                    />
                                    <label>
                                      Click here if billing address is same as
                                      GST address
                                    </label>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            {!this.state.gstChecked && (
                              <tr>
                                <td>
                                  <div className="pad-top-20">
                                    <h6 className="camp_label">
                                      Billing Address
                                    </h6>
                                    <textarea
                                      className="gst_address"
                                      rows="3"
                                      cols="30"
                                      name="billing_Address"
                                      value={
                                        billing_Address
                                          ? billing_Address
                                          : userInfo.communication &&
                                            userInfo.communication.address
                                          ? `${userInfo.communication.address.plot}, ${userInfo.communication.address.street}, ${userInfo.city}, ${userInfo.state} - ${userInfo.communication.pincode}`
                                          : ""
                                      }
                                      disabled={
                                        userInfo.communication &&
                                        userInfo.communication.address
                                      }
                                      onChange={this.handleChange}
                                      placeholder="Enter Billing Address"
                                    ></textarea>
                                  </div>
                                </td>
                                <td align="top" className="vAlignTop">
                                  <div className="lenght_file_wrapper pad-top-20">
                                    <div className="flie_audio">
                                      {!bill_address_cert_file &&
                                        !bill_address_cert_file_path &&
                                        !userInfo.uploadeddocuments && (
                                          <div>
                                            <h6 className="camp_label">
                                              Billing Addres Proof
                                            </h6>
                                            <Drag
                                              getUploadedFile={
                                                this.getUploadedFileBill
                                              }
                                            />
                                          </div>
                                        )}

                                      {(bill_address_cert_file ||
                                        bill_address_cert_file_path) &&
                                        (!userInfo.uploadeddocuments ||
                                          !userInfo.uploadeddocuments
                                            .addressproof) &&
                                        !this.state.gstChecked && (
                                          <div className="upload_file">
                                            <h6 className="camp_label">
                                              Uploaded Billing Addres
                                            </h6>
                                            <div>
                                              <div className="audio_img">
                                                {" "}
                                                <img src="../../assets/images/song.svg" />
                                              </div>
                                              <div className="file_desc">
                                                <div className="file_name_size">
                                                  <div className="file_name">
                                                    {bill_address_cert_file
                                                      ? bill_address_cert_file.path
                                                      : bill_address_cert_file_path.slice(
                                                          bill_address_cert_file_path.lastIndexOf(
                                                            "_"
                                                          ) + 1
                                                        )}
                                                  </div>
                                                  <span className="file_size">
                                                    {bill_address_cert_file
                                                      ? bill_address_cert_file.size
                                                      : null}
                                                  </span>
                                                </div>
                                                <div
                                                  className="remove_file"
                                                  onClick={this.removeFileBill}
                                                >
                                                  <a>REMOVE</a>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      {userInfo.uploadeddocuments &&
                                        userInfo.uploadeddocuments
                                          .addressproof && (
                                          <div className="upload_file">
                                            <h6 className="camp_label">
                                              Uploaded Billing Addres
                                            </h6>
                                            <div>
                                              <div className="audio_img">
                                                {" "}
                                                <img src="../../assets/images/song.svg" />
                                              </div>
                                              <div className="file_desc">
                                                <div className="file_name_size">
                                                  <div className="file_name">
                                                    {salesUserInfo
                                                      .uploadeddocuments
                                                      .addressproof
                                                      ? salesUserInfo.uploadeddocuments.addressproof.split(
                                                          "/"
                                                        )[
                                                          salesUserInfo.uploadeddocuments.addressproof.split(
                                                            "/"
                                                          ).length - 1
                                                        ]
                                                      : "Not Available"}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </table>

                          { userInfo.role == 'dsa' && (
                            <p style={{ margin: "10px 0px" }}>
                              <a href="#" onClick={ (e)=>{ e.preventDefault(); this.setState({ isClientKYCShowing: true }) } }>Submit Client KYC</a>
                            </p>
                          )}
                          

                          <GetClientDetailModel 
                            isShown={ this.state.isClientKYCShowing }
                            hide={this.hideClientKYCModel}
                            close={this.closeClientKYCModel}
                          />
                        </div>
                      </div>

                      <div className="disclaimer">
                        <h6>Disclaimer*</h6>
                        <p>
                          <input
                            className="margn-rgt-10"
                            name="gstAgree"
                            onChange={this.handleInputChangeGst}
                            type="checkbox"
                            value={this.state.gstagree}
                          />
                          I understand that if I do not provide GST number &
                          copy of GST certificate, I will not be entitled to
                          receive GST credit on account of all transactions on
                          this website.
                        </p>
                        <p>
                          <input
                            className="margn-rgt-10"
                            name="tand"
                            disabled={!this.state.tandc}
                            type="checkbox"
                            checked={this.state.tandc}
                          />
                          Click{" "}
                          <a
                            target="_blank"
                            className="termsAndConditionsTxt"
                            style={{ cursor: "pointer" }}
                            onClick={this.handleTermsandCond}
                          >
                            here
                          </a>{" "}
                          to read and accept{" "}
                          <a
                            target="_blank"
                            className="termsAndConditionsTxt"
                            style={{ cursor: "pointer" }}
                            onClick={this.handleTermsandCond}
                          >
                            Terms and Conditions
                          </a>
                          . By clicking "Proceed", I authorize company's
                          representatives to contact me or my designated
                          representative regarding the status of registration as
                          well as to provide information, offers or tips about
                          company's products and services.
                        </p>
                      </div>
                    </div>

                   {!showPaymentModel &&<ToastContainer />}
                    {(!this.state.gstagree || !this.state.tandc) && (
                      <div msg="TO proceed, kindly accept Terms & Conditions" />
                    )}
                  </div>
                  <div className="create_camp_cost">
                    <div className="camp_cost_card">
                      <h5>Campaign Details</h5>

                      <li className="cost_list_inner">
                        <div className="cost_type"> Station Name </div>
                        <div>
                          {" "}
                          <span className="cost_inner">
                            {this.state.compaignData.station && Array.isArray(this.state.compaignData.station) && this.state.compaignData.station.length > 1 ? (
                              <a
                                onClick={(e) => {
                                  this.setState({
                                  showstationlist: true,
                                  currentStations: this.state.compaignData.station
                                  })
                                }}
                              >
                                Multiple ({this.state.compaignData.station.length})
                              </a>
                            ) : (
                              this.state.compaignData.station
                            )}
                          </span>{" "}
                        </div>
                      </li>

                      <li className="cost_list_inner">
                        <div className="cost_type"> Package Type </div>
                        <div>
                          {" "}
                          <span className="cost_inner">
                            {this.state.compaignData.type}
                          </span>{" "}
                        </div>
                      </li>

                      <h5>Campaign Cost</h5>
                      <ul className="camp_cost_list">
                        <li className="cost_list_inner">
                          <div className="cost_type">Package Cost</div>
                          <div className="rupee_symb">
                            <img src="../../assets/images/rupee-indian.svg" />
                            <span className="cost_inner">{packageCost}</span>
                          </div>
                        </li>
                        {compaignData.nonFCTCodeAmount > 0 ? (
                          <li className="cost_list_inner">
                            <div className="cost_type">NON FCT Amount</div>
                            <div className="rupee_symb">
                              <img src="../../assets/images/rupee-indian.svg" />
                              <span className="cost_inner">
                                {compaignData.nonFCTCodeAmount}
                              </span>
                            </div>
                          </li>
                        ): ''}
                        {compaignData && compaignData.audioCost > 0 && (
                          <li className="cost_list_inner">
                            <div className="cost_type">Audio Cost</div>
                            <div className="rupee_symb">
                              <img src="../../assets/images/rupee-indian.svg" />
                              <span className="cost_inner">
                                {compaignData.audioCost}
                              </span>
                            </div>
                          </li>
                        )}
                        {compaignData &&
                          compaignData.audioDiscount > 0 &&
                          compaignData.audioCost && (
                            <li className="cost_list_inner">
                              <div className="cost_type">Discount</div>
                              <div className="rupee_symb">
                                <img src="../../assets/images/rupee-indian.svg" />
                                <span className="cost_inner">
                                  {compaignData.audioDiscount}
                                </span>
                              </div>
                            </li>
                          )}
                        {compaignData.couponDiscount && (
                          <li className="cost_list_inner">
                            <div className="cost_type coupon_discount">
                              Coupon Discount
                            </div>
                            <div className="rupee_symb">
                              <img src="../../assets/images/rupee-indian.svg" />
                              <span className="cost_inner">
                                {compaignData.couponDiscount}
                              </span>
                            </div>
                          </li>
                        )}
                        <li className="cost_list_inner">
                          <div className="cost_type">Taxes@18%</div>
                          <div className="rupee_symb">
                            <img src="../../assets/images/rupee-indian.svg" />
                            <span className="cost_inner">
                              {compaignData ? compaignData.taxes : ""}
                            </span>
                          </div>
                        </li>
                        <div className="totalcost">
                          <div className="cost_type ">Total Cost</div>
                          <div className="rupee_symb">
                            <img src="../../assets/images/rupee-indian_white.svg" />
                            <span className="cost_inner">
                              {compaignData.totalCost}
                            </span>
                          </div>
                        </div>
                      </ul>
                      {compaignData.pendingAmount > 0 && (
                        <div>
                          <ul className="camp_cost_list">
                            <h5 className="camp_pay_now">Amount Payable Now</h5>
                            <li className="cost_list_inner">
                              <div className="cost_type">
                                Audio cost + Taxes
                              </div>
                              <div className="rupee_symb">
                                <img src="../../assets/images/rupee-indian.svg" />
                                <span className="cost_inner">
                                  {compaignData.totalCost -
                                    compaignData.pendingAmount}
                                </span>
                              </div>
                            </li>
                          </ul>

                          <ul className="camp_cost_list">
                            <h5 className="camp_pay_now">
                              Amount to be Paid after audio Approval
                            </h5>
                            <li className="cost_list_inner">
                              <div className="cost_type">Package + Taxes</div>
                              <div className="rupee_symb">
                                <img src="../../assets/images/rupee-indian.svg" />
                                <span className="cost_inner">
                                  {compaignData.pendingAmount}
                                </span>
                              </div>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                    <div className="cost_button pad-top-200">
                      <button className="cncl" onClick={this.showHideModel}>
                        CANCEL
                      </button>
                      <button
                        className="procd"
                        onClick={this.showHidePaymentModel}
                      >
                        PROCEED
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.state.handletermsandcondpopup && (
            <DSATermsPopup
              isShowing={true}
              acceptterms={this.acceptterms}
              hide={this.declineterms}
            />
          )}
                {this.state.showstationlist && (
                <ShowStations
                  stations={this.state.currentStations}
                  closeAction={this.hideshowstations}
                />
              )}
        </div>
        <Model isShowing={showModel} hide={this.showHideModel} />
        <PaymentModel
          isShowing={showPaymentModel}
          hide={this.hidePaymentModel}
          makePayment={this.makePayment}
          submitTransactionDetails={this.submitTransactionDetails}
          payamount={this.state.compaignData.totalCost - this.state.compaignData.pendingAmount}
          savedraft={this.state.savedraft}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    kycDetails: state.user.get("kycDetails"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getKycDetails: (url, data, type) =>
      dispatch(postServerDataWithTypes(url, data, type)),
    createCompain: (url, data, path) =>
      dispatch(postServerDataWithPath(url, data, path)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(KycDetail);



// WEBPACK FOOTER //
// ./web/components/campaign/kycDetail.js